export function formatDeadline(value: string, now = Date.now()): string {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '마감을 넣어 주세요';
  const days = Math.ceil((date.getTime() - now) / 86400000);
  return `${new Intl.DateTimeFormat('ko-KR', { month: 'long', day: 'numeric', weekday: 'short', hour: 'numeric', minute: '2-digit' }).format(date)} · ${days >= 0 ? `D-${days}` : `D+${-days}`}`;
}
